import { render, staticRenderFns } from "./input-link.vue?vue&type=template&id=39020c70&scoped=true"
import script from "./input-link.vue?vue&type=script&lang=js"
export * from "./input-link.vue?vue&type=script&lang=js"
import style0 from "./input-link.vue?vue&type=style&index=0&id=39020c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39020c70",
  null
  
)

export default component.exports